<template>
   <div>
     <Modal
        width="1000"
        v-model.trim="modal"
        :title="`(${detail.name})相册`"
        :loading="loading"
    >
        <c-list
        :data="list.items"
        :columns="cList.columns"
        :total="list.total"
        :page-current="listPageCurrent"
        :search-where="listSearchWhere"
        @selection-change="handleListSelectionChange"
        >
        <c-list-header>
            <c-list-operations>
                <Button type="primary" @click="$refs.form.show({artistId: detail.id})">新增</Button>
            </c-list-operations>
            <c-list-search>
            <Form
                class="c-form c-form--search"
                inline
                @submit.native.prevent="searchWhere"
            >
                <Form-item prop="status">
                <Select
                    class="c-form__input"
                    placeholder="请选择状态"
                    clearable
                    v-model="cList.cSearch.where.status.$eq"
                >
                    <Option
                    v-for="item in dicts.PublishStatus"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                    >{{ item.label }}
                    </Option>
                </Select>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="searchWhere">查询</Button>
                </Form-item>
            </Form>
            </c-list-search>
        </c-list-header>
        </c-list>
    </Modal>

    <c-artist-img-form ref="form" @get-list="getList"></c-artist-img-form>
   </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import ArtistImgForm from "./form";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import ListMixin from "view-ui-admin/src/mixins/list";

const module = "artistimg";
const initWhere = {
  status: {
    $eq: ""
  },
  artistId: {
    $eq: ""
  }
};

@Component({
  mixins: [RouteParamsMixin, ListMixin],
  components: {
    "c-artist-img-form": ArtistImgForm,
  },
  computed: mapState({
    list: state => state[module].list
  })
})
export default class extends Vue {
  data() {
    const {  OrderAction } = this.$consts;

    return {
      modal: false,
      loading: false,
      detail:{},
      cList: {
        columns: [
          {
            type: "selection",
            width: 60,
          },
          {
            title: "照片",
            render: (h, { row }) => {
              return h("c-list-image", {
                props: {
                  src: this.$helpers.getImageUrl({
                    id: row.image,
                    width: 80,
                    height: 80
                  })
                }
              });
            }
          },
          {
            title: "状态",
            render: (h, { row }) =>
              h(
                "span",
                null,
                this.$helpers.getItem(
                  this.dicts.PublishStatus,
                  "value",
                  row.status
                )["label"]
              )
          },
          {
            title: "操作",
            key: "action",
            render: (h, { row }) =>
              h("div", [
                h("c-dropdown", {
                  props: {
                    width: 90,
                    title: "修改状态",
                    options: this.dicts.PublishStatus
                  },
                  on: {
                    click: action => {
                      this.changeStatus(row.id, action);
                    }
                  }
                }),
                h("c-dropdown", {
                  attrs: {
                    title: "排序",
                    options: OrderAction
                  },
                  on: {
                    click: action => {
                      this.order(row.id, action);
                    }
                  }
                }),
                h("c-confirm-button", {
                  props: {
                    buttonText: "删除",
                    confirmText: "确认删除？"
                  },
                  on: {
                    ok: () => {
                      this.confirmDelete(row.id);
                    }
                  }
                })
              ])
          }
        ],
        cSearch: {
          where: this.$helpers.deepCopy(initWhere)
        }
      }
    };
  }

  async beforeRouteUpdate(to, from, next) {
    this.initListSearchWhere(initWhere);
    this.getList();
    next();
  }

  async created() {
    this.initListSearchWhere(initWhere);
  }

  searchWhere() {
    this.getList();
  }

  show(detail) {
    initWhere.artistId = {
         $eq: detail.id
    }
    this.initListSearchWhere(initWhere);
    this.modal = true;
    this.detail = detail;
    this.getList();
  }

  getList() {
    return this.$store.dispatch(`${module}/getList`, {
      query: {
        offset: (this.listPageCurrent - 1) * this.$consts.PageSize,
        limit: this.$consts.PageSize,
        where: this.cList.cSearch.where,
        order: [["order", "DESC"]]
      }
    });
  }

  async confirmDelete(ids) {
    await this.$store.dispatch(`${module}/delete`, { id: ids });
    this.$Message.success("删除成功");

    const { items } = await this.getList();
    !items.length && this.goListPrevPage();
  }

  async changeStatus(id, action) {
    await this.$store.dispatch(`${module}/put`, {
      id,
      body: {
        status: action
      }
    });
    this.$Message.success("修改状态成功");
    this.getList();
  }

  async order(id, action) {
    await this.$store.dispatch(`${module}/postAction`, {
      id,
      action: "order",
      query: {
        where: this.listSearchWhere || initWhere
      },
      body: { action }
    });

    this.$Message.success("排序成功");
    this.getList();
  }
}
</script>
